import _objectSpread from "/home/runners/actions-runner/_work/jd-warranty-ui-core/jd-warranty-ui-core/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import 'isomorphic-fetch';
export function fetch(input, options) {
  var fetchOptions = _objectSpread({}, options);
  var defaultHeaders = {
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  };
  var request;
  fetchOptions.credentials = fetchOptions.credentials || 'same-origin';
  fetchOptions.headers = _objectSpread(_objectSpread({}, defaultHeaders), fetchOptions.headers);
  request = global.fetch(input, fetchOptions);
  return request.then(function (response) {
    if (!response.ok) {
      return Promise.reject(response);
    }
    return response;
  });
}